export const Experiment = {
  OttaCues: "20220720_OTTACUES",
  NewNotificationSettings: "20230621_NOTIFICATION_SETTINGS",
  CVUpload: "20230726_CV_UPLOAD",
} as const;
